export default __webpack_public_path__ + "static/media/screenShots_jewelry-1.12d10bd2.jpg";